import { apiFetch } from './api.js';

export type DeveloperMcpGrantStatus = 'active' | 'expired' | 'revoked';

export interface DeveloperMcpGrant {
  id: string;
  clientId: string;
  clientLabel: string;
  scopes: string[];
  status: DeveloperMcpGrantStatus;
  createdAt: string;
  lastUsedAt: string;
  expiresAt: string | null;
  revokedAt: string | null;
}

export interface DeveloperMcpWorkspaceGrant extends DeveloperMcpGrant {
  member: { id: string; name: string };
}

export interface DeveloperMcpGrants {
  plan: string;
  canManageWorkspaceGrants: boolean;
  mine: DeveloperMcpGrant[];
  workspace: DeveloperMcpWorkspaceGrant[] | null;
}

function grantsPath(workspaceId: string): string {
  return `/workspaces/${encodeURIComponent(workspaceId)}/developer/mcp/grants`;
}

export function listDeveloperMcpGrants(workspaceId: string): Promise<DeveloperMcpGrants> {
  return apiFetch<DeveloperMcpGrants>(grantsPath(workspaceId));
}

export async function revokeDeveloperMcpGrant(workspaceId: string, grantId: string): Promise<void> {
  await apiFetch(`${grantsPath(workspaceId)}/${encodeURIComponent(grantId)}`, { method: 'DELETE' });
}

export function revokeAllMyDeveloperMcpGrants(workspaceId: string): Promise<{ revoked: number }> {
  return apiFetch<{ revoked: number }>(`${grantsPath(workspaceId)}/revoke-all-mine`, {
    method: 'POST',
  });
}
